import React from 'react'

import { useWizard } from '../Wizard/useWizard/useWizard'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation } from '@percent/admin-dashboard/common/hooks'
import { ConfirmationCodeStep } from './ConfirmationCodeStep'
import { ConfirmationCodeContainerProps } from './ConfirmationCodeStep.types'

export function ConfirmationCodeStepContainer({ setUserData }: ConfirmationCodeContainerProps) {
  const { setNextStep } = useWizard()
  const { authService } = useServices()
  const [{ errorMessage, isLoading }, { apiFunc: verifyFunc }] = useMutation(
    authService.confirmOtpKey,
    ({ data: { data } }) => {
      setUserData(data)
      setNextStep()
    }
  )

  return <ConfirmationCodeStep errorMessage={errorMessage} isLoading={isLoading} verifyFunc={verifyFunc} />
}
